package app.nestbridge.config

import kotlin.Boolean
import kotlin.Int
import kotlin.String

internal object BuildKonfig {
  public val applicationId: String = "app.nestbridge"

  public val identityServiceUrl: String = "https://identity.api.nestbridge.app"

  public val childServiceUrl: String = "https://child.api.nestbridge.app"

  public val stytchPublicToken: String = "public-token-live-dfef15e0-142f-4f6d-8119-942e73336006"

  public val googleClientId: String =
      "661307489300-qsnkbnn508jh8mn3isjd0ua8elnte8nj.apps.googleusercontent.com"

  public val stytchTokenExpirationMinutes: Int = 5

  public val stytchSessionDurationMinutes: Int = 6

  public val sessionInactivityMinutes: Int = 3

  public val stytchOauthCallbackPort: Int = 7800

  public val passkeyDomain: String = "nestbridge.app"

  public val useLocalAuthenticator: Boolean = false

  public val httpLogLevel: String = "ALL"

  public val sentryDsn: String =
      "https://ac3f1b2e77f6348fad91ab9463d956d2@o4510937275039744.ingest.us.sentry.io/4511572545044480"

  public val sentryDebug: Boolean = false

  public val sentryTracesSampleRate: String = "0.2"

  public val httpMaxRetries: Int = 0
}
